import React from "react";
import sculptureImage from '../../images/sculptures.jpg';
import CategoryPage from '../CategoryPage';

function SculpturePage() {
    const details = [
        "Évaluation basée sur l’époque, le matériau, l’état, et l’identité de l’artiste, si authentifiée.",
        "Matériaux recherchés : bronze, pierre, bois, résine, régule, marbre, et albâtre.",
        "Les artistes renommés comme Rodin, Giacometti ou Picasso influencent directement la valeur.",
        "Les sculptures en marbre ou albâtre sont très prisées.",
        "Les sculptures en plâtre ont généralement une valeur plus modeste.",
        "Toutes les tailles considérées, des petites figurines aux grandes statues.",
    ];

    return (
        <CategoryPage
            title="Sculpture"
            image={sculptureImage}
            description="Vous avez une sculpture d’art et souhaitez la vendre ? Nous rachetons ce type de pièce. Pour évaluer sa valeur, nous prenons en compte l’époque, le matériau, l’état ainsi que l’identité de l’artiste, si la pièce peut être authentifiée. Les sculptures peuvent varier, allant de petites figurines à de grandes statues, réalisées dans des matériaux tels que le bronze, la pierre, le bois ou la résine, et le régule."
            details={details}
        />
    );
}

export default SculpturePage;
